import { ReactElement, Ref } from "react";
import styles from "./ReorderableList.module.less";
import classNames from "classnames";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { Icon } from "../Icon/Icon";

export type ReorderableListDragHandleProps = {
	isReorderEnabled: boolean;
	ref?: Ref<HTMLButtonElement>;
};

export const ReorderableListDragHandle = (props: ReorderableListDragHandleProps): ReactElement => {
	const {
		isReorderEnabled,
		ref
	} = props;

	return (
		<ButtonBase
			trackingId="drag-handle"
			ref={ref}
			disabled={!isReorderEnabled}
			className={
				classNames(
					styles.dragHandle,
					{
						[styles.dragHandle_disabled]: !isReorderEnabled
					}
				)
			}
		>
			<Icon value="grip-lines" size="large" />
		</ButtonBase>
	);
};

ReorderableListDragHandle.displayName = "ReorderableList.DragHandle";